import type { ReactNode } from "react";

export function PageHeader({
  title,
  description,
  action,
  className = "",
}: {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <header className={className}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-display text-xl font-extrabold lg:text-2xl">{title}</h1>
          {description ? (
            <p className="mt-1 max-w-2xl text-xs text-white/50 lg:text-sm">{description}</p>
          ) : null}
        </div>
        {action}
      </div>
    </header>
  );
}
